import React from "react";
import "./AboutUs.css";
import FadeUp from "../FadeUp/FadeUp";

const AboutUs = ({ isAlbanian }) => {
  return (
    <div>
      <div className="abouteus-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="abouteus-content">
            <div className="abouteus-right">
              <h2>
              <FadeUp>
                {(isAlbanian
                  ? `Vila-L Group është një kompani ndërtimi me bazë në Tiranë, Shqipëri, me mbi 20 vite eksperiencë në sektorin e ndërtimeve rezidenciale dhe komerciale.\n
    Kompania është e njohur për realizimin e projekteve të komplekseve rezidenciale, duke përdorur materialet dhe teknikat më të mira të ndërtimit në vend, si dhe për integritetin dhe vlerat që përfaqëson.\n
    Ekipi i Vila-L është profesionalisht i trajnuar dhe siguron realizimin e të gjitha fazave të një projekti, nga dizajni arkitektonik dhe inxhinierik deri në zbatimin e tij.`
                  : `Vila-L Group is a leading construction company based in Tirana, Albania, with over 20 years of experience in the residential and commercial building sector.\n
    The company is recognized for executing large-scale projects and residential complexes, utilizing the best construction materials and techniques in the country, as well as for the integrity and values it represents.\n
    The Vila-L team is professionally trained and ensures the completion of all phases of a project, from architectural and engineering design to its implementation.`
                )
                  .split("\n")
                  .map((text, index) => (
                    <span key={index}>
                      {text}
                      <br />
                    </span>
                  ))}
                  </FadeUp>
              </h2>
            </div>
            <div className="abouteus-left">
              <div
                className="abouteus-title"
              >
                <FadeUp>
                {isAlbanian ? "Rreth Nesh" : "About Us"}
                </FadeUp>
              </div>
            </div>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
